export const GETPESSOABYCPF = "GETPESSOABYCPF";
export const GETPESSOABYCPFSAGA = "GETPESSOABYCPFASAGA";
